import React from 'react';
import { get, useController, useFormContext } from 'react-hook-form';
import { Checkbox as ReactCheckbox, ControlGroup, Field } from '@panwds/react-ui';
/**
 * Creates a group of checkboxes. These will be added as an object with
 * the checkbox value as the key, and true/false representing if it was checked.
 */
export const CheckboxGroup = (props) => {
    const { items, label, name, register: registerOptions = {}, description, tooltip, disabled, showLabel, defaultValue = {} } = props;
    const context = useFormContext();
    /* istanbul ignore next */
    if (context === null) {
        throw new Error('Attempted to render CheckboxGroup outside of a Form context. Make sure your component is rendered inside <Form>.');
    }
    const { formState } = context;
    const { field: { onChange, value: values } } = useController({
        name,
        defaultValue: defaultValue,
        rules: registerOptions
    });
    return (React.createElement(Field, { label: label, optional: !registerOptions.required, control: React.createElement(ControlGroup, null, items.map(({ value, ...rest }) => {
            return (React.createElement(ReactCheckbox, { key: value, ...rest, checked: !!values[value], onChange: () => {
                    const newValues = { ...values };
                    newValues[value] = !newValues[value];
                    onChange(newValues);
                } }));
        })), error: get(formState.errors, name)?.message, description: description, tooltip: tooltip, disabled: disabled, connectLabel: false, showLabel: showLabel, requiredAsterisk: props.requiredAsterisk }));
};
//# sourceMappingURL=CheckboxGroup.js.map